import React from 'react';
// import RouterGuard from '@/components/RouterGuard'
import type { Route } from '@/types/common';

const GuildHall = React.lazy(() => import('@/pages/Guild/Hall'));
const GuildCreate = React.lazy(() => import('@/pages/Guild/Create'));
const GuildHome = React.lazy(() => import('@/pages/Guild/index'));
const GuildInfo = React.lazy(() => import('@/pages/Guild/Info'));
const GuildInfoEdit = React.lazy(() => import('@/pages/Guild/InfoEdit'));
const GuildMembersConsole = React.lazy(
  () => import('@/pages/Guild/Members/console'),
);
const GuildMembersApply = React.lazy(
  () => import('@/pages/Guild/Members/apply'),
);
const GuildMembers = React.lazy(() => import('@/pages/Guild/Members'));

/**
 * 外管
 */
const GuildManageHome = React.lazy(() => import('@/pages/Guild/Manage'));
const GuildManageIssueGift = React.lazy(
  () => import('@/pages/Guild/Manage/IssueGift'),
);
const GuildManageGuildApply = React.lazy(
  () => import('@/pages/Guild/Manage/GuildApply'),
);
const GuildManageBDList = React.lazy(
  () => import('@/pages/Guild/Manage/BDList'),
);
const GuildManageBDGuildData = React.lazy(
  () => import('@/pages/Guild/Manage/BDGuildData'),
);
const GuildManageGuildData = React.lazy(
  () => import('@/pages/Guild/Manage/GuildData'),
);
const GuildManageMemberData = React.lazy(
  () => import('@/pages/Guild/Manage/MemberData'),
);
const GuildManageGiftUserLv = React.lazy(
  () => import('@/pages/Guild/Manage/GiftUserLv'),
);
// const GuildManageGuildList = React.lazy(
//   () => import('@/pages/Guild/Manage/GuildList')
// );

/**
 * BD
 */
const GuildBDHome = React.lazy(() => import('@/pages/Guild/BD'));

// 角色判断
const GuildRoleJudge = React.lazy(() => import('@/pages/Guild/RoleJudge'));
// 数据中心
const GuildDataCenter = React.lazy(() => import('@/pages/Guild/DataCenter'));
// 数据中心-公会数据
const GuildDataDetail = React.lazy(
  () => import('@/pages/Guild/DataCenter/DataDetail'),
);

const guildRoutes: Route[] = [
  {
    path: '/guild/hall',
    name: 'GuildHall',
    title: '公会大厅',
    // meta: {
    //   noAuthLogin: 0, // 不需要登录
    // },
    element: <GuildHall />,
  },
  {
    path: '/guild/create',
    name: 'GuildCreate',
    title: '创建公会',
    meta: {
      // noAuthLogin: 0, // 不需要登录
    },
    element: <GuildCreate />,
  },
  {
    path: '/guild',
    name: 'GuildHome',
    title: '公会首页',
    element: <GuildHome />,
  },
  {
    path: '/guild/info',
    name: 'GuildInfo',
    title: '公会信息',
    element: <GuildInfo />,
  },
  {
    path: '/guild/info-edit',
    name: 'GuildInfoEdit',
    title: '编辑公会信息',
    element: <GuildInfoEdit />,
  },
  {
    path: '/guild/members-console',
    name: 'GuildMembersConsole',
    title: '成员管理控制台',
    element: <GuildMembersConsole />,
  },
  {
    path: '/guild/apply',
    name: 'GuildApply',
    title: '加入公会申请',
    element: <GuildMembersApply />,
  },
  {
    path: '/guild/members',
    name: 'GuildMembers',
    title: '成员列表',
    element: <GuildMembers />,
  },

  /**
   * 外管
   */
  {
    path: '/guild/manage',
    name: 'GuildManageHome',
    title: '外管',
    element: <GuildManageHome />,
  },
  {
    path: '/guild/manage/issue-gift',
    name: 'GuildManageIssueGift',
    title: '发放礼包',
    element: <GuildManageIssueGift />,
  },
  {
    path: '/guild/manage/guild-apply',
    name: 'GuildManageGuildApply',
    title: '公会申请',
    element: <GuildManageGuildApply />,
  },
  {
    path: '/guild/manage/bd-list',
    name: 'GuildManageBDList',
    title: 'BD列表',
    element: <GuildManageBDList />,
  },
  {
    path: '/guild/manage/bd-guild-data',
    name: 'GuildManageBDGuildData',
    title: '公会数据',
    meta: {},
    element: <GuildManageBDGuildData />,
  },
  {
    path: '/guild/manage/guild-data',
    name: 'GuildManageGuildData',
    title: '公会数据',
    element: <GuildManageGuildData />,
  },
  {
    path: '/guild/manage/member-data',
    name: 'GuildManageMemberData',
    title: '公会成员',
    element: <GuildManageMemberData />,
  },
  // {
  //   path: '/guild/manage/guild-list',
  //   name: 'GuildManageGuildList',
  //   title: '公会列表',
  //   element: <GuildManageGuildList />,
  // },
  {
    path: '/guild/bd',
    name: 'GuildBDHome',
    title: 'BD 中心',
    element: <GuildBDHome />,
  },
  {
    path: '/guild/role-judge',
    name: 'GuildRoleJudge',
    title: '',
    element: <GuildRoleJudge />,
  },
  {
    path: '/guild/data-center',
    name: 'GuildDataCenter',
    title: '数据中心',
    element: <GuildDataCenter />,
  },
  {
    path: '/guild/data-detail',
    name: 'GuildDataDetail',
    title: '数据明细',
    element: <GuildDataDetail />,
  },
  {
    path: '/guild/manage/gift-user-lv',
    name: 'GuildManageGiftUserLv',
    title: '赠送等级', // 赠送财富等级或赠送魅力等级
    element: <GuildManageGiftUserLv />,
  },
];

export default guildRoutes;
